export const GENERATION_ENDPOINTS = [
	'/v1/pipes/run',
	'/beta/chat',
	'/beta/generate',
]
